import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiButton-outlinedSecondary': {
            border: `2px solid ${theme.palette.primary.main}`
        },
        '& .MuiButton-outlinedSecondary:hover': {
            backgroundColor: theme.palette.primary.dark,
            color: '#ffffff',
            border: `2px solid ${theme.palette.primary.dark}`
        },
        '& .MuiButton-containedSecondary:hover': {
            backgroundColor: theme.palette.primary.light,
            boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)'
        }
    }
}));


const CustomButton = ({ variant, label, size, color, style, handleChange, disabled }) => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Button variant={variant} disabled={disabled || false} size={size} color={color} style={style} onClick={handleChange}>
                {label}
            </Button>
        </div>
    )
}

export default CustomButton